import React from 'react'

import { AllocationsOverview } from '@components/AllocationsOverview'
import { ParticipantFilter } from './ParticipantFilter'

export const JointAssetAllocations = ({ participantsQueries, jointAssetAllocation}) => {
  const [selectedParticipantId, setSelectedParticipantId] = React.useState('both')
  const selectedParticipantQuery = participantsQueries.find((participantQuery) => participantQuery.participant.id === selectedParticipantId)


  const assetAllocation = selectedParticipantQuery
    ? selectedParticipantQuery?.assetAllocation.data.baseScenario.assetAllocation
    : jointAssetAllocation

  return (
    <>
      <AllocationsOverview
        filter={ () => (
          <ParticipantFilter
            showBoth
            filteredItemsName={'asset allocations'}
            participantsQueries={participantsQueries}
            selectedParticipantId={selectedParticipantId}
            setSelectedParticipantId={setSelectedParticipantId}
          />
        )}
        style={{ height: '100%' }}
        assetAllocationsDataset={
          [assetAllocation]
        }
      />
    </>
  )
}
